import { type MouseEvent } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { world } from '../../../../../../../languages';
import refetchCart from '../../../../../../../services/cart/refetch-cart';
import usePaymentOptions from '../../../../../../../services/payment/use-payment-options';
import qualityEvents from '../../../../../../../services/quality-events/quality-events';
import { useAppSelector } from '../../../../../../../store';
import isProduction from '../../../../../../../utils/is-production';
import { AdyeConfig } from '../../../../../../../api/payment/get-payment-options';
import { PAYMENT_METHOD_KEYS } from '../../../../../../../constants/payment-method-keys';
import { resetErrors, validateForm } from '../../../../../reducers';
import AdyenBtn from '../../adyen-button';

const GooglePayBtn = () => {
    const { paymentCart } = useAppSelector((state: RootState) => state.payment);
    const currency = useAppSelector((state: RootState) => state.main.currency);
    const { data: paymentOptionsData } = usePaymentOptions(currency.code);
    const user = useAppSelector((state: RootState) => state.main.user);
    const merchantData = paymentOptionsData?.adyen.filter((adyenData: AdyeConfig) => adyenData.type === 'googlepay');
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const handleCaptureClick = (e: MouseEvent<HTMLDivElement>) => {
        const isValid = dispatch(validateForm());

        if (!isValid) {
            e.nativeEvent.stopImmediatePropagation();
        }
    };

    const onButtonClicked = (resolve: () => void, reject: () => void) => {
        refetchCart(queryClient);
        dispatch(resetErrors());

        const isInvoiceFormValid = dispatch(validateForm());

        if (!isInvoiceFormValid) {
            // @ts-ignore
            reject({ statusCode: 'CANCELED' });
        } else {
            qualityEvents.checkoutPage.startPayment(user.id, PAYMENT_METHOD_KEYS.GOOGLE_PAY, paymentCart?.finalPrice);

            resolve();
        }
    };

    const config = {
        configuration: {
            merchantName: merchantData && merchantData[0]?.configuration.gatewayMerchantId,
            merchantId: merchantData && merchantData[0]?.configuration.merchantId,
            gatewayMerchantId: merchantData && merchantData[0]?.configuration.gatewayMerchantId
        },
        buttonType: 'buy',
        buttonLocale: world,
        transactionInfo: {
            totalPriceStatus: 'ESTIMATED'
        },
        environment: isProduction() ? 'PRODUCTION' : 'TEST',
        onClick: onButtonClicked
    };

    return (
        <div onClickCapture={handleCaptureClick}>
            <AdyenBtn paymentType='googlepay' paymentMethodConfiguration={config} />
        </div>
    );
};

export default GooglePayBtn;
